import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { Button } from "antd";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [jwtToken, setJwtToken] = useState(null);

  useEffect(() => {
    const token = Cookies.get("jwtToken");
    if (token) {
      setJwtToken(token);
    }

    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      setScrolled(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const signOut = () => {
    Cookies.remove("jwtToken");
    setJwtToken(null);
    location.reload();
  };

  return (
    <div
      className={`fixed top-0 left-0 w-full h-20 text-gray-800 z-50 font-sans transition-all duration-300 ease-in-out ${
        scrolled ? "bg-btn-1 shadow-md" : "bg-blue-100"
      }`}
    >
      <div className="container mx-auto px-6 flex items-center justify-between h-full">
        <Link to="/">
          <img
            className="h-12 w-auto"
            src={"https://d1irs7zslorh1g.cloudfront.net/logo.png"}
            alt="Logo"
          />
        </Link>
        <nav
          className={`${
            showMobileMenu
              ? "fixed inset-0 h-screen w-full bg-blue-500 flex flex-col items-center justify-center z-40"
              : "hidden"
          } md:flex md:flex-row md:items-center md:space-x-6`}
        >
          {/* <Link to="/browse" className="text-gray-800 hover:text-gray-500 my-2 md:my-0 text-sm">
            Browse Fundraisers
          </Link>
          <Link to="/causes" className="text-gray-800 hover:text-gray-500 my-2 md:my-0 text-sm">
            Causes
          </Link> */}
          {/* <Link to="/about" className="text-gray-800 hover:text-gray-500 my-2 md:my-0 text-sm">
            About
          </Link> */}
          <Link to="/how-it-works" className="text-gray-800 hover:text-gray-500 my-2 md:my-0 text-sm">
            How It Works
          </Link>
          {/* <Link to="/pricing" className="text-gray-800 hover:text-gray-500 my-2 md:my-0 text-sm">
            Pricing
          </Link> */}
          {jwtToken ? (
            <>
              <Link to="/dashboard" className="text-gray-800 hover:text-gray-500 my-2 md:my-0 text-sm">
                Dashboard
              </Link>
              <Button
                className="bg-[#2d98b3] hover:bg-blue-700 text-white px-4 py-1 rounded my-2 md:my-0 text-sm"
                onClick={signOut}
              >
                Sign Out
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" className="my-2 md:my-0 mx-0">
                <Button className="bg-[#2d98b3] hover:bg-blue-700 text-white px-4 py-1 rounded text-sm">
                  Sign In
                </Button>
              </Link>
              <Link to="/register">
                <Button className="bg-[#2d98b3] hover:bg-green-500 text-white px-4 py-1 rounded text-sm ">
                  Sign Up
                </Button>
              </Link>
            </>
          )}
        </nav>
        <div
          className="md:hidden cursor-pointer text-gray-800 text-2xl z-50"
          onClick={toggleMobileMenu}
        >
          {showMobileMenu ? "✕" : "☰"}
        </div>
      </div>
      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-8 rounded-lg text-center">
            <h2 className="text-xl font-bold mb-4">Coming Soon!</h2>
            <p className="text-gray-700 mb-4">This feature is in development and will be available soon.</p>
            <Button className="bg-blue-800 text-white px-4 py-1 rounded" onClick={() => setShowPopup(false)}>
              Close
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
